import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "width", "height"];
import React from 'react';

var ClickAndCollect = function ClickAndCollect(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    width: width,
    height: height
  }, props, {
    viewBox: "0 0 21 34",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.096 23.353c.129 0 .258.043.387.086.345.13.603.387.732.689l2.454 6.243 1.895-.732-2.497-6.415c-.13-.345-.13-.732.086-1.034.172-.301.473-.56.86-.603l5.124-.947L3.015 5.183v20.925l4.435-2.626c.215-.086.43-.13.646-.13m2.885 9.817c-.474 0-.948-.3-1.12-.775l-2.368-6.07-5.037 2.97c-.388.216-.862.216-1.206 0-.387-.215-.603-.602-.603-1.076V1.998c0-.517.302-.948.775-1.12.474-.172.99-.043 1.335.301L20.41 20.597c.301.345.387.775.258 1.206-.13.43-.517.732-.947.818l-5.856 1.076 2.411 6.157c.13.302.13.646 0 .947-.129.302-.387.517-.688.646L11.41 33.04c-.172.086-.301.13-.43.13"
  }));
};

ClickAndCollect.displayName = 'ClickAndCollect';
export default ClickAndCollect;